// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statsContainer_EW_7Y {
    width: 90%;
    display: flex;
    gap: 10px;
    margin-bottom: 12px;

    .statsItem_bWZ3i {
        display: flex;
        flex-direction: column;
        gap: 10px;
        border: 1px solid #E0E0E0;
        border-radius: 8px;
        padding: 6px 8px;
        width: 100%;
        /* background: var(--f5-background); */
        position: relative;

        .statsItemTitle_kZCE_ {
            display: flex;
            flex-direction: row;
            gap: 10px;

            p {
                font-weight: 600;
                color: var(--9ca3af-color);
                margin: 0px;
                font-size: 12px;
                text-transform: uppercase;
            }
        }

        svg {
            position: absolute;
            top: 6px;
            right: 5px;
            width: 38px;
            height: 38px;
        }

        .statsItemValue_yO1Ix {
            display: flex;
            flex-direction: row;
            gap: 10px;

            p {
                font-size: 34px;
                font-weight: 600;
                color: var(--1e293b-color);
                margin: 0px;
                line-height: 25px;
            }
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/StatsAutomate/StatsAutomate.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,SAAS;IACT,mBAAmB;;IAEnB;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,sCAAsC;QACtC,kBAAkB;;QAElB;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;;YAET;gBACI,gBAAgB;gBAChB,0BAA0B;gBAC1B,WAAW;gBACX,eAAe;gBACf,yBAAyB;YAC7B;QACJ;;QAEA;YACI,kBAAkB;YAClB,QAAQ;YACR,UAAU;YACV,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;;YAET;gBACI,eAAe;gBACf,gBAAgB;gBAChB,0BAA0B;gBAC1B,WAAW;gBACX,iBAAiB;YACrB;QACJ;IACJ;AACJ","sourcesContent":[".statsContainer {\n    width: 90%;\n    display: flex;\n    gap: 10px;\n    margin-bottom: 12px;\n\n    .statsItem {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        border: 1px solid #E0E0E0;\n        border-radius: 8px;\n        padding: 6px 8px;\n        width: 100%;\n        /* background: var(--f5-background); */\n        position: relative;\n\n        .statsItemTitle {\n            display: flex;\n            flex-direction: row;\n            gap: 10px;\n\n            p {\n                font-weight: 600;\n                color: var(--9ca3af-color);\n                margin: 0px;\n                font-size: 12px;\n                text-transform: uppercase;\n            }\n        }\n\n        svg {\n            position: absolute;\n            top: 6px;\n            right: 5px;\n            width: 38px;\n            height: 38px;\n        }\n\n        .statsItemValue {\n            display: flex;\n            flex-direction: row;\n            gap: 10px;\n\n            p {\n                font-size: 34px;\n                font-weight: 600;\n                color: var(--1e293b-color);\n                margin: 0px;\n                line-height: 25px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsContainer": `statsContainer_EW_7Y`,
	"statsItem": `statsItem_bWZ3i`,
	"statsItemTitle": `statsItemTitle_kZCE_`,
	"statsItemValue": `statsItemValue_yO1Ix`
};
export default ___CSS_LOADER_EXPORT___;
